@if (vehicle$ | async) {
  <div class="row">
    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
      <div class="row flex items-center">
        <span class="pseudo-icon heading-icon warning"></span>
        <h2
          dsContent
          class="bold-header title-heading"
          [contentPath]="
            (isPartner$ | async)
              ? 'policy.changeCoverage.updateCoverageAgentsHelpHeader'
              : 'policy.changeCoverage.updateCoverageAgentHelpHeaderAFI'
          "
        ></h2>
      </div>
      @if (showVehicleInfo) {
        <div class="vehicle-title">
          <div class="row vehicle">
            <div class="flex self-center pad-10">
              <div class="self-center pad-right-10" aria-hidden="true">
                <span class="icon-auto"></span>
              </div>
              <div class="self-center">
                <div class="risk-info">
                  <div
                    class="caption"
                    dsContent
                    [contentPath]="'policy.changeCoverage.updateCoverageCaption'"
                  ></div>
                  <div class="heading">
                    {{ (vehicle$ | async).description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="agent-help-body">
        <p
          dsContent
          [contentPath]="
            (isPartner$ | async)
              ? 'policy.changeCoverage.updateCoverageAgentsHelpBody'
              : 'policy.changeCoverage.updateCoverageAgentHelpBodyAFI'
          "
        ></p>
      </div>
    </div>
    <div class="row margin-top-50 column twelve lg-push-two md-eight md-push-two">
      <call-to-action
        [capitalize]="(isPartner$ | async) === false"
        [displayBackButton]="true"
        backButtonName="Back"
        tertiaryButtonName="Cancel"
        [primaryButtonName]="(isPartner$ | async) ? 'SEND TO AN ADVISOR' : 'Send to My Agent'"
        (primaryEvent)="sendToAgent()"
        (tertiaryEvent)="cancel()"
        (backEvent)="goBackOneStep()"
      ></call-to-action>
    </div>
  </div>
}
